export default "__VITE_ASSET__C$zrfblZ__"